<template>
    <div>
        <h5>
            취소 안내
        </h5>
        <hr>
        <div  class="row">
            <pre v-html="msg" style="white-space: pre-wrap;">
            </pre>
        </div>
    </div>


</template>

<script>
    export default {
        name: 'ActivityRegistCancel',
        props: {
            msg: String
        }
    }
</script>
